(async function () {
  function formatMoney(cents, currency) {
    // Enkel money-format utan att använda theme helpers
    const value = (cents / 100).toFixed(0);
    return `${value} ${currency || "SEK"}`;
  }

  async function buildCardFromHandle(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    const p = await res.json();

    const img = (p.images && p.images[0]) ? p.images[0] : null;
    const price = p.price; // i cents
    const url = p.url || `/products/${p.handle}`;
    const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : "SEK";

    const wrapper = document.createElement("div");
    wrapper.className = "auto-product-card";
    wrapper.innerHTML = `
      <a class="auto-product-card__media" href="${url}">
        ${img ? `<img loading="lazy" src="${img}" alt="${p.title}">` : ""}
      </a>
      <div class="auto-product-card__body">
        <a class="auto-product-card__title" href="${url}">${p.title}</a>
        <div class="auto-product-card__price">${formatMoney(price, currency)}</div>
        <a class="auto-product-card__cta" href="${url}">Se produkten</a>
      </div>
    `;
    return wrapper;
  }

  function extractHandleFromUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      const m = u.pathname.match(/\/products\/([^\/\?#]+)/);
      return m ? m[1] : null;
    } catch (e) {
      return null;
    }
  }

  async function init() {
    // Begränsa till själva artikelinnehållet så vi inte råkar plocka menyer osv
    const containers = document.querySelectorAll(".rte, .article__content, .blog-post__content");
    if (!containers.length) return;

    for (const container of containers) {
      const links = Array.from(container.querySelectorAll('a[href*="/products/"]'))
        .filter(a => !a.closest(".auto-product-card"))
        .filter(a => a.dataset.autocard !== "0"); // sätt data-autocard="0" för att avaktivera per länk

      for (const a of links) {
        const handle = extractHandleFromUrl(a.getAttribute("href"));
        if (!handle) continue;

        // Om länken redan ligger i en lista med massa länkar kan du välja att bara göra kort på vissa:
        // här kräver vi en markering för att skapa kort: data-autocard="1"
        if (a.dataset.autocard !== "1") continue;

        const card = await buildCardFromHandle(handle);
        if (!card) continue;

        a.replaceWith(card);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", init);
})();
